import styled from "styled-components";
import { Button } from "antd";
import { COLORS } from "../../layout/theme";

export const AntdPrimaryButton = styled(Button)`
	height: 35px;
	padding: 0 28px;
	border-radius: 14px;
	border: none;
	background: linear-gradient(
		90deg,
		${COLORS.Primary} 0%,
		${COLORS.Primary} 100%
	);
	color: ${COLORS.White};
	font-size: 16px;
	font-weight: 700;
	box-shadow: 0 8px 18px rgba(79, 70, 229, 0.22);

	&:hover,
	&:focus,
	&:active {
		background: linear-gradient(
			90deg,
			${COLORS.Primary} 0%,
			${COLORS.Primary} 100%
		) !important;
		color: ${COLORS.White} !important;
		border: none !important;
	}

	@media only screen and (max-width: 768px) {
		width: 100%;
	}
`;

export const AntdSecondaryButton = styled(Button)`
	height: 35px;
	padding: 0 28px;
	border-radius: 14px;
	border: none;
	background: linear-gradient(
		90deg,
		${COLORS.Secondary} 0%,
		${COLORS.Secondary} 100%
	);
	color: ${COLORS.White};
	font-size: 16px;
	font-weight: 700;
	box-shadow: 0 6px 14px rgba(15, 23, 42, 0.08);

	&:hover,
	&:focus,
	&:active {
		background: linear-gradient(
			90deg,
			${COLORS.Secondary} 0%,
			${COLORS.Secondary} 100%
		) !important;
		color: ${COLORS.White} !important;
		border: none !important;
	}

	@media only screen and (max-width: 768px) {
		width: 100%;
	}
`;

export const AntdTerciaryButton = styled(Button)`
	height: 35px;
	padding: 0 28px;
	border-radius: 14px;
	border: none;
	background: linear-gradient(
		90deg,
		${COLORS.Default} 0%,
		${COLORS.Default} 100%
	) !important;
	color: ${COLORS.White};
	font-size: 16px;
	font-weight: 700;
	box-shadow: 0 6px 14px rgba(15, 23, 42, 0.08);
	margin-right: 5px;

	&:hover,
	&:focus,
	&:active {
		background: linear-gradient(
			90deg,
			${COLORS.Default} 0%,
			${COLORS.Default} 100%
		) !important;
		color: ${COLORS.White} !important;
		border: none !important;
	}

	@media only screen and (max-width: 768px) {
		width: 100%;
	}
`;

export const AntdDefaultButton = styled(Button)`
	height: 35px;
	padding: 0 28px;
	border-radius: 14px;
	border: 1px solid ${COLORS.MediumGrey};
	background: ${COLORS.White};
	color: #1f2937;
	font-size: 16px;
	font-weight: 700;
	box-shadow: 0 6px 14px rgba(15, 23, 42, 0.08);
	margin-right: 5px;

	&:hover,
	&:focus,
	&:active {
		background: #d1d5db !important;
		color: #111827 !important;
		border: none !important;
	}

	@media only screen and (max-width: 768px) {
		width: 100%;
	}
`;
